<template>
  <div class="MonitoringSwipe">
    <span
      :class="['treeMonitoringIcon']"
      @click="openMonitorVideo"
      v-if="selectValue"
    ></span>

    <!-- <van-field
        readonly
        clickable
        :value="selectValue ? selectValue : '监控设备' "
        :is-link="monitorList && monitorList.length > 1"
        @click="selectMonitorPicker = true"
      />
      -->
    <span class="selectMonitor" @click="selectMonitorPicker = true"
      >监控设备
      <em
        >{{ selectValue ? selectValue : "请选择"
        }}<van-icon name="arrow" class="rightIcon"
      /></em>
    </span>
    <div class="MonitoringBox clearfix" id="MonitoringBox">
      <ul class="clearfix">
        <li
          v-for="(item, index) in collectionList"
          :key="index"
          class="sensorItem fl"
          @click="openLineChart(item)"
        >
          <p>{{ item.name }}</p>
          <p>
            <span
              >{{ item.data }} <em>{{ item.unit }}</em></span
            >
          </p>
          <p>{{ item.createTime }}</p>
        </li>
      </ul>
    </div>
    <!-- 弹出框 -->
    <van-popup v-model="selectMonitorPicker" round position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="monitorList"
        @cancel="selectMonitorPicker = false"
        @confirm="onSaveMonitorItem"
      />
    </van-popup>
    <!-- 图表 -->
    <div v-if="linerChartShow" :class="['linePopup']">
      <p class="closeBtn" @click="closeLinerChart"><van-icon name="close" /></p>
      <div class="chartPage">
        <p class="chartTit">{{ sensorTypeName }}：最近24小时数据</p>

        <div class="linerMain">
          <p class="ydw">
            单位{{ sensorUnitType ? "（" + sensorUnitType + "）" : "" }}
          </p>
          <p class="xdw">单位（h）</p>
          <ve-line
            :data="chartData"
            :init-options="initOptions"
            :settings="chartSettings"
            :extend="chartExtend"
            :height="lineHeight"
          ></ve-line>
        </div>
      </div>
    </div>
    <!-- 监控视频 -->
    <div class="MonitorVideoBox">
      <van-popup
        v-model="showMonitorVideo"
        class="monitorVideo"
        :closeable="true"
      >
        <monitor :device="deviceId" :appType="appType"></monitor>
      </van-popup>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
const lineChart = () => import("@/components/treeModule/lineChart");
const monitor = () => import("@/components/treeModule/monitor");
import { Websokit } from "@/api/config";
export default {
  name: "monitoringSwipe",
  components: {
    lineChart,
    monitor,
  },
  props: {
    appType: {
      type: String,
      default: "",
    },
  },
  data() {
    this.chartDataZoom = [{ type: "slider" }];
    this.chartExtend = {
      legend: {
        //抬头
        show: false,
      },
      // tooltip: {
      //   trigger: "axis",
      //   axisPointer: {
      //     // 坐标轴指示器，坐标轴触发有效
      //     type: "line", // 默认为直线，可选为：'line' | 'shadow'
      //   },
      // },
      xAxis: {
        type: "category",
        boundaryGap: true,

        // axisLabel: {
        //   interval: 4,
        //   rotate: 35,
        // },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#999",
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
            },
          },
        },
        // grid: {
        //   //    x: 40,
        //   x2: 10, //图与右侧的边距
        //   y2: 80, //图与下边的边距
        // },
      },
      yAxis: {
        axisLabel: {
          textStyle: {
            color: "#333",
            fontSize: 14,
          },
        },

        axisLine: {
          show: false,
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: "dashed",
          },
        },
      },
    };
    this.chartSettings = {
      area: true, //是否显示为面积图
      yAxisType: "linear",
      itemStyle: {
        //面积图颜色设置
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          // normal: {
          //   //设置折线折点
          //   color: "#FFDB9B",
          // },
          colorStops: [
            {
              offset: 0,
              color: "rgba(255, 167, 10, 1)", // 0% 处的颜色
            },
            {
              offset: 0.5,
              color: "rgba(255, 167, 10, .8)", // 100% 处的颜色
            },
            {
              offset: 0.7,
              color: "rgba(255, 167, 10, .5)", // 100% 处的颜色
            },
            {
              offset: 1,
              color: "rgba(255, 167, 10, .2)", // 100% 处的颜色
            },
          ],
          // globalCoord: false
        },
      },
    };
    this.initOptions = {
      renderer: "svg",
    };
    return {
      treeId: "",
      deviceId: "",
      dataMsg: {},
      showData: [],
      collectionList: [],
      websocket: null,
      showLineChart: false, //折线图显示
      chartSource: "", //列表详情
      selectValue: "", //选中的监控设备值
      selectMonitorPicker: false, //选择监控设备弹窗
      monitorList: [], //监控设备
      showMonitorVideo: false, //监测视频是否开启
      linerChartShow: false, //折线图是否显示
      chartData: {
        //数据
        columns: [],
        rows: [],
      },
      sensorTypeName: "",
      sensorUnitType: "",
      lineWidth: "100%", //宽度
      lineHeight: "350px", //高度
      socket: "",
      num: 1,
    };
  },

  mounted() {
    this.treeId = this.$route.query.treeId || "";
    this.fristConnect();
    this.getTextId();
  },
  methods: {
    fristConnect() {
      var _this = this;
      let device = Date.parse(new Date());
      var opts = {
        query: "device=" + device + "&project_code=tree_protect",
        transports: ["websocket", "xhr-polling", "jsonp-polling"],
      };
      console.log(Websokit);
      _this.socket = window.io.connect(Websokit, opts);

      // console.log(typeof _this.socket)
    },
    getTextId() {
      let _this = this;
      _this.$api.slbkOldTree
        .getTreeDetail(_this.treeId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.$nextTick(() => {
              if (res.data.monitors && res.data.monitors[0]) {
                _this.monitorList = res.data.monitors;
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    connect(device) {
      var _this = this;
      var sendMsg = {
        device: device,
      };
      _this.socket.on("connect", function (data) {
        console.log("连接成功");
      });
      console.log(device, "device");
      _this.socket.emit("text", sendMsg);
      _this.socket.on("push_event", function (data) {
        let pushObj = {};
        pushObj = data;     
        if (pushObj.device == device && pushObj.projectCode == "tree_protect") {
          _this.$nextTick(() => {
            if (pushObj.source == "init") {
              //第一次给全部数据
              _this.collectionList = []; //初始化前置空
              for (let i in pushObj.data) {
                _this.collectionList.push(pushObj.data[i]);
              }
            } else if (pushObj.source == "normal") {
              //第二次给更新数据
              for (let i in pushObj.data) {
                let arr = _this.collectionList;
                arr.forEach((item, index) => {
                  if (item.key == i) {
                    _this.$set(
                      _this.collectionList[index],
                      "data",
                      pushObj.data[i].data
                    );
                    _this.$set(
                      _this.collectionList[index],
                      "createTime",
                      pushObj.data[i].createTime
                    );
                  }
                });
              }
            }
          });
        }
      });

      _this.socket.on("disconnect", function () {
        console.log("已经下线");
      });
    },
    onSaveMonitorItem(data) {
      //保存选择设备
      let _this = this;
      _this.selectMonitorPicker = false;
      _this.selectValue = data.name;
      _this.collectionList = [];
      _this.connect(data.device);
      _this.deviceId = data.device;
    },

    //折线图表
    openLineChart(item) {
      let _this = this;
      _this.sensorTypeName = item.name;
      _this.sensorUnitType = item.unit;
      _this.$api.slbkOldTree
        .getTreechart(_this.deviceId, item.key, _this.appType)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.linerChartShow = true;
            _this.chartData.columns = ["日期", "数值"];
            _this.chartData.rows = [];
            let NewObject = {};
            // let cc = res.data.splice(0, 100);
            for (let i = 0; i < res.data.length; i++) {
              NewObject = {
                日期: res.data[i].time,
                数值: res.data[i].data,
              };
              _this.chartData.rows.push(NewObject);
            }
            console.log(_this.chartData.rows, "rows");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    closeLinerChart() {
      this.linerChartShow = false;
    },
    //古树监测
    openMonitorVideo() {
      this.showMonitorVideo = true;
    },
  },
};
</script>
<style  lang="less">
@import "./css/monitoringSwipe.less";
</style>